import { render } from "./Cases.vue?vue&type=template&id=489a1c60&scoped=true"
const script = {}

import "./Cases.vue?vue&type=style&index=0&id=489a1c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489a1c60"]])

export default __exports__